module.exports = __webpack_public_path__ + "media/images/front/mid_g/banner_minnna-9777ef18a19527d0eec4189d0ad01ed4.png";